<template>
  <div>
    <AdminDashboard v-if="user.managerOrHigher" />
    <ClientDashboard v-if="user.role == 'client'" />
    <EmployeeDashboard v-if="user.role == 'employee'" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import EmployeeDashboard from '@/components/dashboard/employee-dashboard.vue'
import ClientDashboard from '@/components/dashboard/client-dashboard.vue'
import AdminDashboard from '@/components/dashboard/admin-dashboard.vue'

export default {
  components: {
    EmployeeDashboard,
    ClientDashboard,
    AdminDashboard,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
